
export default ({ request }) => ({
  get_top_statistics() {
    return request({
      url: `/platform/v1/dashboard/top_statistics`,
      method: 'get'
    })
  },
  get_calender(params) {
    return request({
      url: `/platform/v1/dashboard/calender`,
      method: 'get',
      params: params
    })
  },
  get_production_individual_stats() {
    return request({
      url: `/platform/v1/dashboard/production_individual_stats`,
      method: 'get'
    })
  },
  get_production_overview() {
    return request({
      url: `/platform/v1/dashboard/production_overview`,
      method: 'get'
    })
  }
})
